
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#070808","d":"M7.5 1.075A6.433 6.433 0 0113.926 7.5 6.433 6.433 0 017.5 13.925 6.433 6.433 0 011.075 7.5 6.433 6.433 0 017.5 1.075m0-1C3.399.075.075 3.399.075 7.5s3.324 7.425 7.425 7.425a7.425 7.425 0 100-14.85z"}}),_c('path',{attrs:{"d":"M9.971 8.196L7.853 6.079a.514.514 0 00-.707 0L5.049 8.177a.5.5 0 00.707.707L7 7.64v4.248a.5.5 0 001 0V7.64l1.264 1.264a.498.498 0 00.707 0 .502.502 0 000-.708zM10.336 4.952h-5.67a.5.5 0 010-1h5.67a.5.5 0 010 1z"}})])
          )
        }
      }
    